import {createSelector} from 'reselect';

import {getUIState} from '../../../../ui-selectors';

const getFacebookState = createSelector([getUIState], (uiState) => uiState.facebook);

const getFacebookChartState = createSelector(
    [getFacebookState],
    (facebook) => facebook.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getFacebookChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getFacebookChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getFacebookChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getFacebookChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
